import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'QFS', path: '/qfs' },
    { name: 'Web3', path: '/web3' },
    { name: '401(k)', path: '/401k' },
    { name: 'Trump Gold Card', path: '/trump-gold-card' },
    { name: 'Medbed', path: '/medbed' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-lg shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center space-x-2 group"
          >
            <div className="w-10 h-10 bg-gradient-to-br from-[#0B2A4A] to-[#FFD700] rounded-lg flex items-center justify-center transform group-hover:scale-110 transition-transform duration-300">
              <span className="text-white font-bold text-xl">F</span>
            </div>
            <span className={`text-xl font-bold transition-colors duration-300 ${isScrolled ? 'text-[#0B2A4A]' : 'text-white'}`}>
              Quantum Finance Guide
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative text-sm font-medium transition-colors duration-300 group ${
                  location.pathname === link.path
                    ? isScrolled ? 'text-[#FFD700]' : 'text-[#FFD700]'
                    : isScrolled ? 'text-[#0B2A4A] hover:text-[#FFD700]' : 'text-white hover:text-[#FFD700]'
                }`}
              >
                {link.name}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#FFD700] transition-all duration-300 group-hover:w-full"></span>
              </Link>
            ))}
          </div>

          {/* Apply Card Button */}
          <div className="hidden lg:block">
            <Link to="/card-application">
              <Button className="bg-[#FFD700] text-[#0B2A4A] hover:bg-[#FFD700]/90 font-semibold px-6 py-2 rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300">
                Apply for Card
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-300"
          >
            {isMobileMenuOpen ? (
              <X className={isScrolled ? 'text-[#0B2A4A]' : 'text-white'} />
            ) : (
              <Menu className={isScrolled ? 'text-[#0B2A4A]' : 'text-white'} />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white/98 backdrop-blur-lg border-t border-gray-200 shadow-2xl animate-in slide-in-from-top duration-300">
          <div className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block text-base font-medium transition-colors duration-300 py-2 ${
                  location.pathname === link.path
                    ? 'text-[#FFD700]'
                    : 'text-[#0B2A4A] hover:text-[#FFD700]'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/card-application" onClick={() => setIsMobileMenuOpen(false)}>
              <Button className="w-full bg-[#FFD700] text-[#0B2A4A] hover:bg-[#FFD700]/90 font-semibold py-3 rounded-lg shadow-lg">
                Apply for Card
              </Button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};
